import {Page_Redirect} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/page.types';
import {
  GetPageMetaDataResponse,
  JsonLD,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/meta/service.types';
import {
  createRedirectHint,
  useRecentFullUrl,
  useUtmParams,
} from '@aboutyou/router';
import {addParamsToUrl} from '@aboutyou/utils';

type RedirectMetaType = {
  meta: {type: {$case: 'redirectUrl'; redirectUrl: Page_Redirect}};
  jsonLd?: JsonLD;
};

const isRedirectData = (
  data: GetPageMetaDataResponse,
): data is RedirectMetaType =>
  (data as GetPageMetaDataResponse).meta?.type?.$case === 'redirectUrl';

export const useEnsureRedirectData = () => {
  const utmParams = useUtmParams();
  const currentFullUrl = useRecentFullUrl();
  return (data: GetPageMetaDataResponse) => {
    if (isRedirectData(data)) {
      const correctedUrl =
        process.env.NODE_ENV !== 'production'
          ? data.meta.type.redirectUrl.url.replace('https', 'http')
          : data.meta.type.redirectUrl.url;
      const redirectUrl = addParamsToUrl(correctedUrl, utmParams);
      if (currentFullUrl === redirectUrl) {
        throw new Error(
          'Cannot redirect to the same url as the website is on as it would result in an endless loop. Please make sure the current url and the redirect url differentiate from each other.',
        );
      }
      throw createRedirectHint(
        redirectUrl,
        data.meta.type.redirectUrl.statusCode,
      );
    }
  };
};
